
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

import './chat-resume.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import CallChatResume from './CallChatResume'
import CallReportResume from './CallReportResume'
import LoadingReport from './LoadingReport'
import ProjectDashboard from './ProjectDashboard'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ReportCall(props) {
    const { data, onClose } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(false)
    const [assement, setAssement] = useState(null)
    const [reportType, setReportType] = useState('summary')
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    useEffect(() => {
        setCall(data)
    }, [data])
    useEffect(() => {
        if (data) {            
            if (data?.url_audio) {
                getCallUrl()
            }
        }
    }, [data])

    const closeReport = () => {
        onClose()
    }

    const getCallUrl = async () => {
        let config = {
            headers: {
                apikey: 'validApikey'
            },
        };

        let body = {
            "key_file": data?.audio_name
        }
        
        let url = `${urlValue}/assesment/audiocall`;
        
        const res = await axios.post(url, body, config)
        if (res.status === 200) {
            document.querySelector('#audioID').src = res.data;
        }
    }

    const getReportsCall = async () => {

        let config = {
            headers: {
                apikey: 'validApikey',
                locale: 'en-US',
                project: 'AI Nesting',
                channel: 'ivr',
                'bussiness-key': call.bussiness_key
            },
        };

        let url = `${urlValue}/assesment/call`;
        const res = await axios.post(url, {
            "sessionCode": call.session_code,
            "project_name": call.project_name,
            "time_seconds": call.time_call_seconds,
            "time_hold": call.AmountTimeHold,
            "second_hold": call.TimeSecondHold,
            "hangcall": call.hang_call,
            "channel": call.channel,
            "percentage_affectation": call.percentage_affectation,
            "end_time": false,
        }, config)

        if (res.status === 200) {
            setAssement(res.data)
        }

    }

    useEffect(() => {
        if (call) {
            getReportsCall()
        }
    }, [call])

    const openTap = (type, e) => {
        document.querySelectorAll('.btn-tap-report').forEach(item => {
            item.classList.remove('active')
        });
        e.currentTarget.classList.toggle('active')
        setReportType(type)
    }
    
    return (
        <div className='cont-reports  '  >
            <div className='content-btn-tap-rp  '>
                <div className='btn-tap-report ' onClick={(e) => { openTap('call', e) }}>
                    Call Report
                </div>
                <div className='btn-tap-report active' onClick={(e) => { openTap('summary', e) }} >
                    Call Summary
                </div>

                <div className='flex-1'></div>
                <div className='btn-tap-report mr-0' style={{ marginRight: 0 }} onClick={(e) => { openTap('project-dashboard', e) }} >
                    Project Dashboard
                </div>
            </div>
            <div className="bg-white w-full  pr-[1rem]">
                <div className="bg-white w-full h-[75vh]  sm:h-[60vh] md:h-[80vh] lg:h-[70%] xl:h-[70vh]   overflow-auto">

                    {reportType === 'summary' &&
                        (assement !== null ? <CallChatResume data={assement} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'call' &&
                        (assement !== null ? <CallReportResume data={assement} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }

                    {reportType === 'project-dashboard' &&
                        (assement !== null ? <ProjectDashboard data={{id: id, id_proyect: call.project}} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    <div className='w-full flex items-center justify-center sticky-audio' style={{ backgroundColor: 'white' }}>
                        <div className='flex items-center' >
                            <div style={{ color: '#0b5fa3', width:130 }}>
                                <span>Play conversation</span>
                            </div>
                            <audio id="audioID" controls >
                                <source type="audio/ogg" />
                            </audio>
                        </div>
                        <div className="btn-close-report  " onClick={closeReport}>
                            Close
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
